/* Utils */
import { Page } from '../models';
import { generateSelectEntityByEntityInfo, generateSelectEntityById } from '../utils/generators/selectorGenerators';

export const selectAllPages = (state) => state.pages;

export const selectPageById = generateSelectEntityById(selectAllPages);
export const selectPageByPageInfo = generateSelectEntityByEntityInfo(selectAllPages, Page);
